import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageHero from './PageHero';

const Privacy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { t } = useTranslation();

  return (
    <div className="privacy-page">
      <PageHero title={t('privacy_title')} />
      <div className="container" style={{ padding: '40px 0' }}>
        <section className="fade-up">
          <h2>{t('privacy_intro_title')}</h2>
          <p>{t('privacy_intro_body')}</p>
        </section>
        <section className="fade-up stagger-1">
          <h2>{t('privacy_collect_title')}</h2>
          <p>{t('privacy_collect_body')}</p>
        </section>
        <section className="fade-up stagger-2">
          <h2>{t('privacy_use_title')}</h2>
          <p>{t('privacy_use_body')}</p>
        </section>
        <section className="fade-up stagger-3">
          <h2>{t('privacy_contact_title')}</h2>
          <p>{t('privacy_contact_body')}</p>
        </section>
      </div>
    </div>
  );
};

export default Privacy;
